import { loyaltySelectors } from './models/loyalty';
import { orderSelectors } from './models/order';
import { orderingSelectors } from './models/ordering';

export const selectors = {
  loyalty: loyaltySelectors,
  order: orderSelectors,
  ordering: orderingSelectors,
};
